import { motion } from "framer-motion";
import { FiArrowUpRight } from "react-icons/fi";

const MobileCards = () => {
    const cards = [
        {
            title: "MOBILIER HABITAT",
            description: "We make pretty buildings",
            imgSrc: "/assets/images/categories/MOBILIER HABITAT.jpg",
            url: "/categories/mobilier/habitat"
        },
        {
            title: "MOBILIER PROFESSIONNEL",
            description: "This ones pretty nice",
            imgSrc: "/assets/images/categories/MOBILIER PROFESSIONNEL.jpg",
            url: "/categories/mobilier/professionnel"
        },
        {
            title: "MOBILIER EXTÉRIEUR",
            description: "We can even do TALL buildings",
            imgSrc: "/assets/images/categories/MOBILIER EXTERIEUR.jpg",
            url: "/categories/mobilier/exterieur"
        },
        {
            title: "LUMINAIRES & ACCESSOIRES",
            description: "You like wavy buildings?",
            imgSrc: "/assets/images/categories/LUMINAIRE & ACCESSOIRE.jpg",
            url: "/categories/objets-accessoires"
        },
        {
            title: "NOS REALISATIONS",
            description: "This one's real blocky",
            imgSrc: "/assets/images/categories/NOS REALISATIONS.jpg",
            url: "/design-and-projects"
        }
    ];

    return (
        // Ne s'affiche que sur mobile (<768px)
        <section className="md:hidden bg-cream">
            <h2 className="text-3xl font-semibold text-center py-8 uppercase">
                Catalogues
            </h2>
            <div className="flex flex-col gap-4 px-4">
                {cards.map((card, index) => (
                    <MobileCard key={index} {...card} />
                ))}
            </div>
        </section>
    );
};

const MobileCard = ({ imgSrc, title, description, url }) => {
    return (
        <motion.div
            className="relative h-48 rounded-lg overflow-hidden shadow-lg"
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
        >
            <a href={url} className="block h-full">
                {/* Image de fond avec overlay */}
                <img 
                    src={`${imgSrc}`}
                    alt={title}
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/50" />
                
                {/* Contenu */}
                <div className="relative h-full p-6 flex flex-col justify-between text-white">
                    <div>
                        <h3 className="text-xl font-semibold mb-2">{title}</h3>
                        <p className="text-sm text-gray-200">{description}</p>
                    </div>
                    
                    {/* Icône */}
                    <div className="self-end">
                        <motion.div
                            whileHover={{ x: 5 }}
                            className="flex items-center gap-2"
                        >
                            <span className="text-sm">Voir plus</span>
                            <FiArrowUpRight className="text-lg" />
                        </motion.div>
                    </div>
                </div>
            </a>
        </motion.div>
    );
};

export default MobileCards;